export enum SocketIntegrationAction {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  PROCESSED = 'PROCESSED',
  PAGES_AVAILABLE = 'PAGES_AVAILABLE',
  QR_AVAILABLE = 'QR_AVAILABLE',
  UNKNOWN = 'UNKNOWN',
}

export interface IFacebookPageOption {
  id: string;
  name: string;
  category?: string;
  tasks?: string[];
  picture_url?: string;
  disabled?: boolean;
  connected_channel_id?: string;
  connected_channel_name?: string;
}

export interface ISocketIntegrationEvent {
  user_id: string;
  company_id: string;
  channel_id: string;
  action: SocketIntegrationAction;
  error?: string;
  data?: {
    qrUrl?: string;
    afterLoginActions?: boolean;
    pages?: IFacebookPageOption[];
  };
}

export interface IViberSocketError {
  code: string;
  chatId?: string;
  companyId: string;
}
